const modalChangePassword = {
  header: 'Cambiar contraseña',
  currentPassword: 'Contraseña actual',
  newPassword: 'Nueva contraseña',
  confirmPassword: 'Confirme la contraseña',
  buttonSubmit: 'Confirmar',
  validation: {
    required: 'Se requiere contraseña',
    leastCharacters: 'La contraseña debe tener al menos 6 caracteres',
    criteria: 'Debe contener letras minúsculas y mayúsculas',
    mustMatch: 'Las contraseñas deben coincidir',
    confirmRequired: 'Confirmar contraseña es obligatorio',
  },
};

export default modalChangePassword;
